'use client';

import Header from './Header';

export default function ClientHeader() {
  return <Header />;
}